import { render } from "./JulySaleHeroSection.vue?vue&type=template&id=f97a4b38&scoped=true"
import script from "./JulySaleHeroSection.vue?vue&type=script&lang=js"
export * from "./JulySaleHeroSection.vue?vue&type=script&lang=js"

import "./JulySaleHeroSection.vue?vue&type=style&index=0&id=f97a4b38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97a4b38"]])

export default __exports__